import { Clip } from 'src/app/shared/components/video-playlist-previewer/clip';
import { ContentRequest, ContentRequestStateName } from '../../shared/api-models/admin';
import { ClipsView, Comment } from '../create-edit-request/_models';

export class CsrHomeContentRequestTable {
	ContentRequest: ContentRequest;
	ClientName: string;
	CsrUsername: string;
	ProducerUsername: string;
	RequestedByUsername: string;

	border: string;
	clipCount: number;
	rowBgColor: string;
	dueDate: string;
	createDate: string;
	approvedDate: string;
	viewBtn: string;
	clientStatusView: string;
	isSelected: boolean;
	CreateDateTime: string;
	DueDate: string;
	StateName: ContentRequestStateName;
}

export class ContentRequestTable {
	Id: number;
	ClientId: number;
	ClientName: string;
	Title: string;
	Description: string;
	RequestType: string;
	ClipCount: number;
	CreateDateTime: string;
	DueDate: string;
	ApprovedDateTime: string | null;
	CompletedDateTime: string | null;
	CreatedBy: number;
	CreatedByName: string;
	VoiceTalent: string;
	RequestedBy: number;
	RequestedByName: string;
	CsrId: number;
	CsrName: string;
	ProducerId: number;
	ProducerName: string;
	StateName: ContentRequestStateName;
	ComplianceTags: string | null;
	TargetLibraryId: number;
	IsGlobalLibrary: boolean;
	RequestApprovalFrom: number;
	LastUpdatedBy: number | null;
	LastUpdatedDateTime: string;

	rowBgColor: string;
	isSelected: boolean;
	viewBtn: string;
	clips: ClipsView[];
	comments: Comment[];
	classList: string;
	clientStatusView: ContentRequestStateName;
}
